import { gql } from '@grandvisionhq/graphql';
import { commercialCategoryFragment } from './fragments/small-fragments.js';
import './fragments/prices/productPriceItem.js';
import './fragments/prices/productPrice.js';
import './fragments/offerings.js';
import { productFragment } from './fragments/product.js';
import { variantFragment } from './fragments/variant.js';

const GET_CONTACT_LENS_BY_SLUG = gql`
  query GetContactLensBySlug($slug: String!) {
    getProductBySlug(slug: $slug) {
      product {
        __typename
        ... on ContactLensProduct {
          id
          ...productFragment
          productTypeDetails {
            isMaster
            productMasterKey
            replacementFrequency
            replacementFrequencyAllLocales {
              locale
              value
            }
          }
          commercialCategories {
            ...CommercialCategoryFragment
          }
          variants {
            ...variantFragment
            gan
            variantTypeDetails {
              channelAvailability
              color
              hasBetterAllRoundVision
              hasBetterHydration
              hasEnhancedSoftness
              hasIncreasedBreathability
              hasLessFatigue
              hasUvProtection
              isMaster
              lensType
              lensTypeAllLocales {
                locale
                value
              }
              masterVariantSku
              material
              materialAllLocales {
                locale
                value
              }
              materialType
              maxQuantityPerVariant
              opticalRanges {
                addition
                axis
                baseCurve
                cylinder
                diameter
                power
              }
              packageQuantity
              recommendedCategoryKey
              waterContent
              subscriptionIntervals
            }
          }
        }
      }
    }
  }
  ${productFragment}
  ${commercialCategoryFragment}
  ${variantFragment}
`;

export { GET_CONTACT_LENS_BY_SLUG };
//# sourceMappingURL=get-contact-lens-by-slug.js.map
